import { createSlice } from '@reduxjs/toolkit'
import { create } from '@bufbuild/protobuf'

import { Corporation, CorporationSchema } from '@/api/form/v1/form_pb'

const newCorporation: Corporation = create(CorporationSchema, {
	id: '',
	name: '',
	capital: '',
	address: '',
	siren: '',
	registar: '',
	delegateGender: '',
	delegateLastName: '',
	delegateFirstName: '',
	delegatePhone: '',
	delegateEmail: '',
	delegateAddress: '',
	kbisFile: '',
	statutsFile: '',
	delegateIdFile: '',
	nonFinancingDeclarationFile: '',
})

type CorporationState = {
	corporations: Corporation[]
}

const initialState: CorporationState = {
	corporations: [],
}

export const corporationSlice = createSlice({
	name: 'Corporation',
	initialState,
	reducers: {
		resetCorporations: state => {
			state.corporations = []
		},
		addCorporation: (state, action) => {
			const corporation = { ...newCorporation, id: action.payload }
			state.corporations.push(corporation)
		},
		removeCorporation: (state, action) => {
			const index = state.corporations.findIndex(corporation => corporation.id === action.payload)
			if (index !== -1) {
				state.corporations.splice(index, 1)
			}
		},
		setCorporationName: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.name =
				action.payload.value
		},
		setCorporationCapital: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.capital =
				action.payload.value
		},
		setCorporationAddress: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.address =
				action.payload.value
		},
		setCorporationSiren: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.siren =
				action.payload.value
		},
		setCorporationRegistar: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.registar =
				action.payload.value
		},
		setCorporationDelegateGender: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.delegateGender =
				action.payload.value
		},
		setCorporationDelegateLastName: (state, action) => {
			state.corporations.find(
				corporation => action.payload.id === corporation.id,
			)!.delegateLastName = action.payload.value
		},
		setCorporationDelegateFirstName: (state, action) => {
			state.corporations.find(
				corporation => action.payload.id === corporation.id,
			)!.delegateFirstName = action.payload.value
		},
		setCorporationDelegatePhone: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.delegatePhone =
				action.payload.value
		},
		setCorporationDelegateEmail: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.delegateEmail =
				action.payload.value
		},
		setCorporationDelegateAddress: (state, action) => {
			state.corporations.find(
				corporation => action.payload.id === corporation.id,
			)!.delegateAddress = action.payload.value
		},
		setCorporationKbisFile: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.kbisFile =
				action.payload.value
		},
		setCorporationStatutsFile: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.statutsFile =
				action.payload.value
		},
		setCorporationDelegateIdFile: (state, action) => {
			state.corporations.find(corporation => action.payload.id === corporation.id)!.delegateIdFile =
				action.payload.value
		},
		setCorporationNonFinancingDeclarationFile: (state, action) => {
			state.corporations.find(
				corporation => action.payload.id === corporation.id,
			)!.nonFinancingDeclarationFile = action.payload.value
		},
	},
})

export const {
	resetCorporations,
	addCorporation,
	removeCorporation,
	setCorporationName,
	setCorporationCapital,
	setCorporationAddress,
	setCorporationSiren,
	setCorporationRegistar,
	setCorporationDelegateGender,
	setCorporationDelegateLastName,
	setCorporationDelegateFirstName,
	setCorporationDelegatePhone,
	setCorporationDelegateEmail,
	setCorporationDelegateAddress,
	setCorporationKbisFile,
	setCorporationStatutsFile,
	setCorporationDelegateIdFile,
	setCorporationNonFinancingDeclarationFile,
} = corporationSlice.actions

export default corporationSlice.reducer
